// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"pY","header":"pZ","headline":"p0","closeIcon":"p1","modalCloseIcon":"p2"};